export default __webpack_public_path__ + "static/media/Quentin.69df21e9.jpg";